import { Component, OnInit } from '@angular/core';
import { UserService } from '../Services/user';
import { AuthService } from '../Services/auth';
import { MessageService } from '../Services/message';
import { Message } from '../Models/message';
import { User } from '../Models/user';


@Component({
  selector: 'inbox',
  templateUrl: '../Templates/inbox.html',
})


export class InboxComponent implements OnInit {

  messages: Message[];
  user: User;

  constructor(private auth: AuthService,
              private msg: MessageService,
              private userService: UserService) { }

  ngOnInit() {

    this.auth.getUser().subscribe(
      user => {
        this.user = user;

        this.msg.list(this.user).subscribe(
          data => { this.messages = data }
        );
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/inbox.ts